// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__17rka","productName":"Table_productName__3JFDM"};